import React from "react";
import coverHigh from "./assets/cover_high.jpg";
import coverLow from "./assets/cover_low.jpg";
import {Box, useMediaQuery} from "@mui/material";
import {styled} from "@mui/material/styles";

const CoverWrapper = styled(Box)({
    width: '100%',
    position: 'relative',
    lineHeight: 0,
    '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        background: 'rgba(0,0,0,0.28)',
        pointerEvents: 'none',
    },
});

const CoverImage = styled('img')({
    width: '100%',
    height: 'auto',
    display: 'block',
});

interface PageWithCoverProps {
    children: React.ReactNode;
}

const PageWithCover = ({children}: PageWithCoverProps) => {
    const isMobile = useMediaQuery('(max-width:900px)');
    const cover = isMobile ? coverHigh : coverLow;

    return (
        <>
            <CoverWrapper>
                <CoverImage src={cover} alt="cover"/>
            </CoverWrapper>
            <Box sx={{maxWidth: "1000px", width: "100%", mx: "auto"}}>
                {children}
            </Box>
        </>
    );
};

export default PageWithCover;